import type { FC } from 'react';

import { t } from '@nodal/i18n';
import { PhoneNumberInput } from '@nodal/uikit/components/PhoneNumberInput';
import { Select } from '@nodal/uikit/components/Select';
import { TextInput } from '@nodal/uikit/components/TextInput';

import { states } from '@core/consts/states';

// NOTE: The component must be embedded inside Formik
export const ObGynDetailsForm: FC<{
  editable: boolean;
}> = ({ editable }) => {
  return (
    <>
      {/* API returns this as an array, but should be an object
       * There will be only one element in the array, so that's why
       * we use index 0 in name (ob_gyn_details.0)
       */}
      <div className="grid grid-cols-1 gap-x-4 gap-y-10">
        <TextInput
          label={"Doctor's Name (optional)"}
          placeholder="Doctor's Name"
          name="ob_gyn_details.0.doctor_name"
          type="text"
          disabled={!editable}
        />
        <PhoneNumberInput
          label={`Doctor's Phone Number (optional)`}
          name="ob_gyn_details.0.doctor_phone_number"
          placeholder={'(555) 987-6543'}
          type="text"
          className="lg:w-1/2"
          disabled={!editable}
        />
        <TextInput
          label={t("Doctor's Clinic Name")}
          placeholder="Doctor's Clinic Name"
          name="ob_gyn_details.0.doctor_clinic_name"
          type="text"
          disabled={!editable}
        />
        <div className="grid grid-cols-1 gap-x-4 lg:grid-cols-2">
          <TextInput
            label={"Doctor's Clinic City"}
            placeholder="Doctor's Clinic City"
            name="ob_gyn_details.0.doctor_clinic_city"
            type="text"
            disabled={!editable}
          />
          <Select
            label={"Doctor's Clinic State"}
            name="ob_gyn_details.0.doctor_clinic_state"
            options={states}
            placeholder="Doctor's Clinic State"
            disabled={!editable}
          />
        </div>
      </div>
    </>
  );
};
